import { service } from '../index.js'

// 首页入口管理
export const homeEntry = {
  // 列表
  list: (params = {}) => {
    return service.get('/home-entry/admin/list', { params })
  },
  // 保存
  save: (data) => {
    return service.post('/home-entry/admin/save', data)
  },
  // 删除
  delete: (data) => {
    return service.post('/home-entry/admin/delete', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/home_entry.js